export const LEGALFRACTION_LOADING = "LEGALFRACTION_LOADING";
export const LEGALFRACTION_RESET = "LEGALFRACTION_RESET";
export const GET_LEGALFRACTION = "GET_LEGALFRACTION";
export const GET_LEGALFRACTION_SUCCESS = "GET_LEGALFRACTION_SUCCESS";
export const GET_LEGALFRACTION_FAIL = "GET_LEGALFRACTION_FAIL";
export const DELETE_LEGALFRACTION = "DELETE_LEGALFRACTION"
export const DELETE_LEGALFRACTION_SUCCESS = "DELETE_LEGALFRACTION_SUCCESS"
export const DELETE_LEGALFRACTION_FAIL = "DELETE_LEGALFRACTION_FAIL"
export const UPDATE_LEGALFRACTION = "UPDATE_LEGALFRACTION"
export const UPDATE_LEGALFRACTION_SUCCESS = "UPDATE_LEGALFRACTION_SUCCESS"
export const UPDATE_LEGALFRACTION_FAIL = "UPDATE_LEGALFRACTION_FAIL"
export const ADD_NEW_LEGALFRACTION = "ADD_NEW_LEGALFRACTION"
export const ADD_LEGALFRACTION_SUCCESS = "ADD_LEGALFRACTION_SUCCESS"
export const ADD_LEGALFRACTION_FAIL = "ADD_LEGALFRACTION_FAIL"